import { render, staticRenderFns } from "./BaseTitle.vue?vue&type=template&id=4d35cf10&scoped=true"
import script from "./BaseTitle.vue?vue&type=script&lang=js"
export * from "./BaseTitle.vue?vue&type=script&lang=js"
import style0 from "./BaseTitle.vue?vue&type=style&index=0&id=4d35cf10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d35cf10",
  null
  
)

export default component.exports